import { Component, OnInit } from '@angular/core';
import { RsbService } from 'src/app/service/rsb.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
@Component({
  selector: 'app-rent-post-publish',
  templateUrl: './rent-post-publish.component.html',
  styleUrls: ['./rent-post-publish.component.css']
})
export class RentPostPublishComponent implements OnInit {

 
  constructor(
    private rsbService: RsbService,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  publish(): void {
    this.rsbService.publishPlan().subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.toastrService.success('Property has been published successfully.');
        this.router.navigate(['myProperties']);
      }
    });
  }
}

